import { InitOptions } from 'i18next'

import { DEFAULT_LOCALE } from 'Core/constants/locale'
import { getEnv } from 'Core/env'

const env = getEnv()

export const NAMESPACES = ['core', 'partials', 'constants', 'menuItems', 'pages']

export const DEFAULT_SETTINGS: InitOptions = {
	lng: DEFAULT_LOCALE,
	fallbackLng: DEFAULT_LOCALE,
	interpolation: {
		escapeValue: false
	},
	react: {
		useSuspense: true
	}
}

export const DEFAULT_LOCIZE_SETTINGS: InitOptions = {
	ns: NAMESPACES, // locize required field for parsing scope of json files, only mentioned namespace will be parsed in locize app.
	defaultNS: NAMESPACES[0],
	load: 'currentOnly', //only specific locale resources loading, avoiding load request duplication, FE: en, en-US, en-UK
	backend: {
		projectId: env.REACT_APP_LOCIZE_PROJECTID,
		apiKey: env.REACT_APP_LOCIZE_API_KEY,
		version: 'latest'
	}
}
